/* AimGrips FAQ Page — live search filter + smooth category nav */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.agfInit === 'true') return;
    root.dataset.agfInit = 'true';

    var input = root.querySelector('[data-agf-search]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-agf-item]'));
    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-agf-cat]'));
    var noResults = root.querySelector('[data-agf-noresults]');
    var nav = root.querySelector('[data-agf-nav]');

    function filter(q) {
      var query = q.trim().toLowerCase();
      var anyVisible = false;

      items.forEach(function (item) {
        var text = (item.getAttribute('data-search') || item.textContent).toLowerCase();
        var match = query === '' || text.indexOf(query) !== -1;
        item.classList.toggle('is-hidden', !match);
        if (match) anyVisible = true;
        /* Auto-expand matches while searching, collapse when cleared */
        if (query !== '') {
          item.open = match;
        } else {
          item.open = false;
        }
      });

      /* Hide empty categories */
      cats.forEach(function (cat) {
        var visible = cat.querySelectorAll('[data-agf-item]:not(.is-hidden)').length;
        cat.classList.toggle('is-hidden', visible === 0);
      });

      if (nav) nav.style.display = query === '' ? '' : 'none';
      if (noResults) noResults.classList.toggle('is-visible', !anyVisible);
    }

    if (input) {
      input.addEventListener('input', function () { filter(input.value); });
    }

    /* Smooth scroll for category nav (with fallback) */
    Array.prototype.forEach.call(root.querySelectorAll('[data-agf-jump]'), function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        var target = id && id.charAt(0) === '#' ? root.querySelector(id) : null;
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-agf]'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
